import script from "./BaseAccordion.vue?vue&type=script&lang=js"
export * from "./BaseAccordion.vue?vue&type=script&lang=js"

import "./BaseAccordion.vue?vue&type=style&index=0&id=54aecb43&scoped=true&lang=scss"

import exportComponent from "/opt/render/project/src/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-54aecb43"]])

export default __exports__